import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';

const Tooltip = ({ content, children, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  return (
    <div className="relative inline-block">
      <div
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        className="cursor-help"
      >
        {children}
      </div>
      
      {isVisible && (
        <div className={`absolute z-50 ${positionClasses[position]} pointer-events-none`}>
          <div className="bg-gray-900 text-white text-xs rounded-lg py-2 px-3 max-w-xs shadow-lg">
            <div className="whitespace-pre-wrap">{content}</div>
            
            {/* Flèche */}
            <div className={`absolute w-2 h-2 bg-gray-900 rotate-45 ${
              position === 'top' ? 'top-full left-1/2 transform -translate-x-1/2 -mt-1' :
              position === 'bottom' ? 'bottom-full left-1/2 transform -translate-x-1/2 -mb-1' :
              position === 'left' ? 'left-full top-1/2 transform -translate-y-1/2 -ml-1' :
              'right-full top-1/2 transform -translate-y-1/2 -mr-1'
            }`}></div>
          </div>
        </div>
      )}
    </div>
  );
};

// Composant spécialisé pour les explications de métriques
export const MetricTooltip = ({ metric, explanation, children }) => {
  const content = `${metric}: ${explanation}`;
  
  return (
    <Tooltip content={content}>
      <span className="inline-flex items-center space-x-1">
        {children}
        <HelpCircle className="w-3 h-3 text-gray-400 hover:text-gray-600" />
      </span>
    </Tooltip>
  );
};

export default Tooltip;